module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"header_1":"Перед началом работы просим","header_2":"ознакомиться с условиями","go_to_help":"Перейти в раздел «Помощь»","do_not_show":"Больше не показывать сообщение"},"en":{"header_1":"Before working with this site","header_2":"please read our terms of use","go_to_help":"Go to the \\"Help\\" page","do_not_show":"Do not show this message anymore"}}')
  delete Component.options._Ctor
}
